/**
 * Comment reactions. The old buttons were: Agree, Disagree, Duly
 * Noted. Marketing replaced two with one. The one is Duly Noted. This
 * module remembers the other two, for the archive.
 */

export type Reaction = "duly-noted" | "agree" | "disagree";

export const REACTION_META: Record<Reaction, { label: string; retired: boolean; weight: number }> = {
  "duly-noted": { label: "Duly noted", retired: false, weight: 1 },
  agree: { label: "Agree", retired: true, weight: 0.4 },
  disagree: { label: "Disagree", retired: true, weight: 0.4 },
};

export interface ReactionTally {
  commentId: string;
  counts: Record<Reaction, number>;
}

export function tally(commentId: string, events: Array<{ commentId: string; reaction: Reaction }>): ReactionTally {
  const counts: Record<Reaction, number> = { "duly-noted": 0, agree: 0, disagree: 0 };
  for (const e of events) {
    if (e.commentId === commentId) counts[e.reaction] += 1;
  }
  return { commentId, counts };
}

/** Retired reactions count at their historic weight; the archive insists. */
export function weighted(t: ReactionTally): number {
  let sum = 0;
  for (const [reaction, count] of Object.entries(t.counts) as Array<[Reaction, number]>) {
    sum += count * REACTION_META[reaction].weight;
  }
  return Math.round(sum * 100) / 100;
}

/** A comment is "settled" when it has been duly noted five times. */
export const SETTLEMENT_THRESHOLD = 5;

export function isSettled(t: ReactionTally): boolean {
  return t.counts["duly-noted"] >= SETTLEMENT_THRESHOLD;
}
